import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full max-w-sm mx-auto rounded-2xl overflow-hidden shadow-xl border border-gray-100 bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center pt-4 px-6"
}
const _hoisted_3 = { class: "inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-800" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "text-gray-300 text-sm italic"
}
const _hoisted_6 = { class: "px-6 py-5 flex flex-col items-center gap-3" }
const _hoisted_7 = { class: "text-2xl font-bold uppercase tracking-wide text-center text-gray-900" }
const _hoisted_8 = { class: "text-sm text-gray-500 text-center leading-relaxed" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-amber-600 font-medium text-center"
}
const _hoisted_10 = {
  key: 1,
  type: "email",
  disabled: "",
  placeholder: "Enter your email",
  class: "w-full rounded-full border border-gray-200 px-4 py-2 text-sm text-gray-400 bg-gray-50 cursor-not-allowed text-center"
}
const _hoisted_11 = {
  key: 2,
  type: "tel",
  disabled: "",
  placeholder: "Enter your phone number",
  class: "w-full rounded-full border border-gray-200 px-4 py-2 text-sm text-gray-400 bg-gray-50 cursor-not-allowed text-center"
}

import { computed } from 'vue'


export default {
  __name: 'PopupCard',
  props: {
  headline: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  imageUrl: {
    type: String,
    default: null
  },
  collectFromCustomer: {
    type: String,
    default: 'none'
  },
  giveReward: {
    type: Boolean,
    default: false
  },
  audience: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props

const AUDIENCE_BADGE_LABELS = {
  all: 'Special Offer',
  first_time: 'First Time Customer Offer',
  returning: 'Returning Customer Offer'
}

const audienceBadgeLabel = computed(() => AUDIENCE_BADGE_LABELS[props.audience] ?? props.audience)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.audience)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(audienceBadgeLabel.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["relative h-40 w-full bg-gray-100 flex items-center justify-center overflow-hidden", __props.audience ? 'mt-3' : ''])
    }, [
      (__props.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.imageUrl,
            class: "w-full h-full object-cover",
            alt: ""
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "No image"))
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.headline || 'Your headline here'), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(__props.text || 'Your body text will appear here.'), 1),
      (__props.giveReward)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Gift reward included"))
        : _createCommentVNode("", true),
      (__props.collectFromCustomer === 'email_address')
        ? (_openBlock(), _createElementBlock("input", _hoisted_10))
        : (__props.collectFromCustomer === 'contact_number')
          ? (_openBlock(), _createElementBlock("input", _hoisted_11))
          : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex flex-col items-center gap-2 w-full mt-1" }, [
        _createElementVNode("button", {
          type: "button",
          disabled: "",
          class: "w-full rounded-full bg-blue-600 text-white font-semibold text-sm py-2 px-6 cursor-default"
        }, " YES, PLEASE "),
        _createElementVNode("button", {
          type: "button",
          disabled: "",
          class: "text-sm text-gray-400 underline cursor-default bg-transparent border-0"
        }, " No thanks ")
      ], -1))
    ])
  ]))
}
}

}